import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "expo-router";
import React, { Fragment } from "react";
import { ScrollView, Text, View } from "react-native";
import AccountItem from "@/elements/components/account/account-item";
import AccountItemDivider from "@/elements/components/account/account-item-divider";
import Loader from "@/elements/components/shared/loader";
import ResponsiveContent from "@/elements/components/shared/responsive-content";
import { AppBar } from "@/elements/components/ui/app-bar";
import { api } from "@/elements/components/utils/convex-api";
import goBack from "@/elements/components/utils/go-back";

function LegalDocumentsScreen() {
  const router = useRouter();

  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {}),
  );

  const persona = currentUser?.persona;

  const { data: documents } = useQuery({
    ...convexQuery(api.legal.queries.getLegalDocuments, {}),
    enabled: persona === "tutor" || persona === "parent",
  });

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  if (persona === "student") {
    goBack(true);
    return <Fragment />;
  }

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <AppBar>
        <AppBar.Icon onPress={goBack} />
        <AppBar.Title>Back</AppBar.Title>
      </AppBar>

      <ScrollView showsVerticalScrollIndicator={false}>
        <ResponsiveContent>
          <View className="mx-5">
            <View className="h-2" />
            <View className="gap-1">
              <Text className="font-zilla-slab-medium font-medium text-dark text-[28px] leading-[1.2]">
                Legal Documents
              </Text>
            </View>
          </View>

          <View className="h-8" />

          {documents?.map((doc) => (
            <Fragment key={doc.documentType}>
              <AccountItemDivider />
              <AccountItem
                title={doc.label}
                onPress={() => {
                  router.push(
                    `/(app)/legal-documents/${doc.documentType}` as any,
                  );
                }}
              />
            </Fragment>
          ))}

          {documents && documents.length > 0 && <AccountItemDivider />}

          <View className="h-8" />
        </ResponsiveContent>
      </ScrollView>
    </View>
  );
}

export default LegalDocumentsScreen;
